import { Outlet } from "react-router-dom";

const Airtime = () => {
  return (
    <div className="bg-white">
      <Outlet />
    </div>
  );
};

export default Airtime;
